// @flow
import RadioSelect from 'fg-frontend/src/components/RadioSelect';
//
import Form from 'fg-frontend/src/components/Form';
import NumberInput from 'fg-frontend/components/NumberInput';
import UniversalPaginationButton from 'fg-frontend/components/UniversalPaginationButton';
// import Typeahead from 'fg-frontend/components/Typeahead';
import Typeahead from './components/Typeahead';
//
// import RadioSelectCustom from './components/RadioSelectCustom';
import SelectDesign from './components/SelectDesign';
import SelectDesignAutoSelection from './components/SelectDesignAutoSelection';
import Tooltip from './components/Tooltip';
import LazyImage from './components/LazyImage';
import UploadFileOverlay from './components/UploadFileOverlay';
import AppealTurnPhone from './components/AppealTurnPhone';
import TogglePassword from './components/TogglePassword';

import CustomDatePicker from './components/CustomDatePicker';
import AccordionComponent from './components/AccordionComponent';
import MenuComponent from './components/Menu/MenuComponent';
import FloatingLabelsComponent from './components/FloatingLabelsComponent';
import MultiSelectTwoSides from './components/MultiSelectTwoSides';
import GridFilterComponent from './components/GridFilter/GridFilterComponent';
import GridFilterDateInput from './components/GridFilter/GridFilterDateInput';
import TableShowDetailRow from './components/TableShowDetailRow';
import BalanceListingComponent from './components/BalanceListingComponent';
import EspPopupCustom from './components/EspPopupCustom';
import OrderFirstChoice from './components/Orders/OrderFirstChoice'; // Krok 1
import OrderBranches from './components/Orders/OrderBranches'; // Krok 3
import OrderNominal from './components/Orders/OrderNominal'; // Krok 4
import OrderDelivery from './components/Orders/OrderDelivery'; // Krok 5
import OrderPayment from './components/Orders/OrderPayment'; // Krok 6
import OrderBillingInfo from './components/Orders/OrderBillingInfo'; // Krok 7
import OrderPickupSLPosta from './components/Orders/OrderPickupSLPosta'; // Krok 8
import CardOrderNominal from './components/Orders/CardOrderNominal';
import CardReplacementOrder from './components/Orders/CardReplacementOrder';
import UniversalPreloader from './components/UniversalPreloader';
import PopupWindow from './components/PopupWindow';
import DiscountWorld from './components/DiscountWorld/DiscountWorld';
import AutomaticAction from './components/AutomaticAction';
// import GoodProgram from './components/GoodProgram/GoodProgram';
import TokenInput from './components/TokenInput';
import CardProductOverviewSlider from './components/CardProductOverviewSlider';
import EntitlementContainer from './components/Canteen/EntitlementContainer';
import JsonMessages from './components/JsonMessages';
import EmployeePaymentsListing from './components/Canteen/EmployeePaymentsListing';
import CanteenEmployeeToggle from './components/Canteen/CanteenEmployeeToggle';
import InlineHelpMessage from './components/Form/InlineHelpMessage';
import TableLayout from './components/TableLayout';
import TextEditor from './components/TextEditor';
import Recipient from './components/Mailing/Recipient';
import MailAttachment from './components/Mailing/MailAttachment';
import MailingInbox from './components/Mailing/MailingInbox';
import Attachment from './components/Attachment';
import FileInputReset from './components/FileInputReset';
import LunchListingSlider from './components/LunchListingSlider';
import AutomaticLogout from './components/AutomaticLogout';
import AutomaticLogoutPopup from './components/AutomaticLogoutPopup';
import ClickTracker from './components/ClickTracker';
import GiftVoucherOrder from './components/GiftVoucherOrder';
import UpdateChargeAfterDate from './components/Admin/UpdateChargeAfterDate';

export default (props) => {
	switch (props.decorator || props.is) {
		case 'UpdateChargeAfterDate':
			return UpdateChargeAfterDate;
		case 'RadioSelect':
		case 'CheckboxSelect':
			return RadioSelect;
		case 'Attachment':
			return Attachment;
		case 'MailAttachment':
			return MailAttachment;
		case 'MailingInbox':
			return MailingInbox;
		case 'TableLayout':
			return TableLayout;
		case 'TextEditor':
			return TextEditor;
		case 'Recipient':
			return Recipient;
		case 'Typeahead':
			return Typeahead;
		case 'SelectDesign':
			return SelectDesign;
		case 'SelectDesignAutoSelection':
			return SelectDesignAutoSelection;
		case 'NumberInput':
			return NumberInput;
		case 'UniversalPaginationButton':
			return UniversalPaginationButton;
		case 'Tooltip':
			return Tooltip;
		case 'Form':
		  	return Form;
		case 'PopupWindow':
			return PopupWindow;
		case 'LazyImage':
		  	return LazyImage;
		case 'CustomDatePicker':
			return CustomDatePicker;
		case 'AccordionComponent':
			return AccordionComponent;
		case 'MenuComponent':
			return MenuComponent;
		case 'FloatingLabelsComponent':
			return FloatingLabelsComponent;
		case 'MultiSelectTwoSides':
			return MultiSelectTwoSides;
		case 'GridFilterComponent':
			return GridFilterComponent;
		case 'GridFilterDateInput':
			return GridFilterDateInput;
		case 'TableShowDetailRow':
			return TableShowDetailRow;
		case 'BalanceListingComponent':
			return BalanceListingComponent;
		case 'EspPopupCustom':
			return EspPopupCustom;
		case 'OrderFirstChoice':
			return OrderFirstChoice;
		case 'OrderNominal':
			return OrderNominal;
		case 'CardOrderNominal':
			return CardOrderNominal;
		case 'OrderDelivery':
			return OrderDelivery;
		case 'OrderBranches':
			return OrderBranches;
		case 'OrderPayment':
			return OrderPayment;
		case 'OrderBillingInfo':
			return OrderBillingInfo;
		case 'OrderPickupSLPosta':
			return OrderPickupSLPosta;
		case 'UniversalPreloader':
			return UniversalPreloader;
		case 'CardReplacementOrder':
			return CardReplacementOrder;
		case 'UploadFileOverlay':
			return UploadFileOverlay;
		case 'AppealTurnPhone':
			return AppealTurnPhone;
		case 'TogglePassword':
			return TogglePassword;
		case 'DiscountWorld':
			return DiscountWorld;
		// case 'GoodProgram':
		// 	return GoodProgram;
		case 'AutomaticAction':
			return AutomaticAction;
		case 'TokenInput':
			return TokenInput;
		case 'CardProductOverviewSlider':
			return CardProductOverviewSlider;
		case 'EntitlementContainer':
			return EntitlementContainer;
		case 'EmployeePaymentsListing':
			return EmployeePaymentsListing;
		case 'JsonMessages':
			return JsonMessages;
		case 'CanteenEmployeeToggle':
			return CanteenEmployeeToggle;
		case 'InlineHelpMessage':
			return InlineHelpMessage;
		case 'FileInputReset':
			return FileInputReset;
		case 'LunchListingSlider':
			return LunchListingSlider;
		case 'AutomaticLogout':
			return AutomaticLogout;
		case 'AutomaticLogoutPopup':
		  return AutomaticLogoutPopup;
		case 'ClickTracker':
			return ClickTracker;
		case 'GiftVoucherOrder':
			return GiftVoucherOrder;
    case 'Signature':
      return import('./components/Signature');
    case 'AddSvgIconSprite':
      return import('./components/AddSvgIconSprite');
    default:
			console.log(`Unknown component ${props.decorator || props.is}`);
			return null;
	}
};



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/configureWebComponents.js